/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
import * as i0 from "@angular/core";
import * as i1 from "@angular/common";
import * as i2 from "./date.component";
var styles_DateComponent = ["[_nghost-%COMP%] {\n      font-size: 13px;\n    }"];
var RenderType_DateComponent = i0.ɵcrt({ encapsulation: 0, styles: styles_DateComponent, data: {} });
export { RenderType_DateComponent as RenderType_DateComponent };
export function View_DateComponent_0(_l) { return i0.ɵvid(0, [i0.ɵpid(0, i1.DatePipe, [i0.LOCALE_ID]), (_l()(), i0.ɵted(1, null, [" ", " "])), i0.ɵppd(2, 2)], null, function (_ck, _v) { var _co = _v.component; var currVal_0 = i0.ɵunv(_v, 1, 0, _ck(_v, 2, 0, i0.ɵnov(_v, 0), (_co.note.createdAt * 1000), "dd.MM.y H:mm")); _ck(_v, 1, 0, currVal_0); }); }
export function View_DateComponent_Host_0(_l) { return i0.ɵvid(0, [(_l()(), i0.ɵeld(0, 0, null, null, 1, "nns-date", [], null, null, null, View_DateComponent_0, RenderType_DateComponent)), i0.ɵdid(1, 49152, null, 0, i2.DateComponent, [], null, null)], null, null); }
var DateComponentNgFactory = i0.ɵccf("nns-date", i2.DateComponent, View_DateComponent_Host_0, { note: "note" }, {}, []);
export { DateComponentNgFactory as DateComponentNgFactory };
//# sourceMappingURL=date.component.ngfactory.js.map